import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=1bc649fa&scoped=true&"
import script from "./ItemDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=1bc649fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc649fa",
  null
  
)

export default component.exports